export const AIChatPurple = {
    // 模块配置
    // AIChat - banner
    "--theme-AIChat-banner-title-color": "white",
    "--theme-AIChat-banner-des-color": "white",
    "--theme-AIChat-banner-btn-color": "white",
    "--theme-AIChat-banner-btn-bg": "#FC7D33",
    // AIChat - explain
    "--theme-AIChat-explain-bg": "white",
    "--theme-AIChat-explain-inner-bg": "white",
    "--theme-AIChat-explain-item-shadow": "none",
    "--theme-AIChat-explain-inner-bg-hover": "#17A18A",
    // AIChat - step
    "--theme-AIChat-step-bg": "#F6F6F6",
    "--theme-AIChat-step-inner-bg": "white",
    "--theme-AIChat-step-inner-bg-hover": "linear-gradient(137deg, #414DF7 0%, #863DFE 100%)",
    "--theme-AIChat-step-title-color": "#111212",
    "--theme-AIChat-step-inner-title-color": "#252325",
    "--theme-AIChat-step-inner-desc-color": "#252325",
    "--theme-AIChat-step-inner-title-color-hover": "white",
    "--theme-AIChat-step-inner-desc-color-hover": "white",
    "--theme-AIChat-step-radius": "0px",
    // AIChat - price
    "--theme-AIChat-price-btn-bg": "#FC7D33",
    "--theme-AIChat-price-btn-bg-hover": "#FC7D33",
    "--theme-AIChat-price-btn-color": "#252325",
    "--theme-AIChat-price-btn-color-hover": "#252325",
    "--theme-AIChat-price-text-color": "#252325",
    "--theme-AIChat-price-text-color-hover": "#FC7D33",
    "--theme-AIChat-price-ul-text-align": "center",
    "--theme-AIChat-price-item-bg": "#F2F2F2",
    "--theme-AIChat-price-item-bg-hover": "linear-gradient(137deg, #414DF7 0%, #863DFE 100%)",
    "--theme-AIChat-price-item-border-radius": "0px",
    "--theme-AIChat-price-light": "#A783FF",
    "--theme-AIChat-price-deep": "#A783FF",
    // AIChat - question
    "--theme-AIChat-question-bg": "#F6F6F6",
    // AIChat - comment
    "--theme-AIChat-comment-border-radius": "0px",
    "--theme-AIChat-comment-item-bg-hover": "linear-gradient(137deg, #414DF7 0%, #863DFE 100%)",
   
   }